import type { PersonalDetailsDto } from '../../models/person/personalDetailsDto';
import type { FileDto } from '../../models/membership/fileDto';
import { requests } from '../httpClient';

export const PersonalDetails = {
    getPersonalDetailsAsync: (personId: string) => requests.get<PersonalDetailsDto>(`Person/${personId}`),
    submitPersonalDetailsAsync: (data: PersonalDetailsDto) => requests.post<void>(`Person`, data),
    updatePersonalDetailsAsync: (data: PersonalDetailsDto) => requests.put<void>(`Person/${data.id}`, data),
    updateVerifyPersonalDetailsAsync: () => requests.put<void>(`Person/VerifyPersonalDetails`, {}),
    getFilesAsync: () => requests.get<FileDto[]>(`Person/Documents`),
    getFileAsync: (id: string, name: string) => requests.getConfig<Blob>(`Person/Document/${id}/${name}`, {
        responseType: 'blob',
    })
};
